/**
 * Hash of all font glyphs for consumers to get a full list of the set and the
 * source locations of the corresponding SVG used to generate the glyph.
 */
export default {
  'activate': 'src/glyphs/activate.svg',
  'activity': 'src/glyphs/activity.svg',
  'add-circle': 'src/glyphs/add-circle.svg',
  'alert': 'src/glyphs/alert.svg',
  'archive': 'src/glyphs/archive.svg',
  'arrow-down': 'src/glyphs/arrow-down.svg',
  'arrow-left': 'src/glyphs/arrow-left.svg',
  'arrow-right': 'src/glyphs/arrow-right.svg',
  'arrow-up': 'src/glyphs/arrow-up.svg',
  'brush': 'src/glyphs/brush.svg',
  'change-owner': 'src/glyphs/change-owner.svg',
  'check-circle': 'src/glyphs/check-circle.svg',
  'checkmark': 'src/glyphs/checkmark.svg',
  'cip-pin': 'src/glyphs/cip-pin.svg',
  'clear': 'src/glyphs/clear.svg',
  'clickable-image': 'src/glyphs/clickable-image.svg',
  'close': 'src/glyphs/close.svg',
  'competition': 'src/glyphs/competition.svg',
  'convert': 'src/glyphs/convert.svg',
  'copy': 'src/glyphs/copy.svg',
  'critical': 'src/glyphs/critical.svg',
  'down-circle': 'src/glyphs/down-circle.svg',
  'download': 'src/glyphs/download.svg',
  'edit': 'src/glyphs/edit.svg',
  'ellipsis': 'src/glyphs/ellipsis.svg',
  'embed-code': 'src/glyphs/embed-code.svg',
  'exit': 'src/glyphs/exit.svg',
  'folder': 'src/glyphs/folder.svg',
  'folder-add': 'src/glyphs/folder-add.svg',
  'folder-closed': 'src/glyphs/folder-closed.svg',
  'folder-locked': 'src/glyphs/folder-locked.svg',
  'folder-move': 'src/glyphs/folder-move.svg',
  'folder-open': 'src/glyphs/folder-open.svg',
  'folder-shared': 'src/glyphs/folder-shared.svg',
  'folder-system': 'src/glyphs/folder-system.svg',
  'folder-upload': 'src/glyphs/folder-upload.svg',
  'folder-user': 'src/glyphs/folder-user.svg',
  'gavel': 'src/glyphs/gavel.svg',
  'gear': 'src/glyphs/gear.svg',
  'info': 'src/glyphs/info.svg',
  'insert': 'src/glyphs/insert.svg',
  'instructions': 'src/glyphs/instructions.svg',
  'link': 'src/glyphs/link.svg',
  'list': 'src/glyphs/list.svg',
  'lock': 'src/glyphs/lock.svg',
  'lock-bold': 'src/glyphs/lock-bold.svg',
  'more-vertical': 'src/glyphs/more-vertical.svg',
  'move': 'src/glyphs/move.svg',
  'multiple-choice': 'src/glyphs/multiple-choice.svg',
  'open-ended': 'src/glyphs/open-ended.svg',
  'pin': 'src/glyphs/pin.svg',
  'play': 'src/glyphs/play.svg',
  'plus': 'src/glyphs/plus.svg',
  'pop-out': 'src/glyphs/pop-out.svg',
  'profile': 'src/glyphs/profile.svg',
  'q-and-a': 'src/glyphs/q-and-a.svg',
  'qr-code': 'src/glyphs/qr-code.svg',
  'ranking': 'src/glyphs/ranking.svg',
  'refresh': 'src/glyphs/refresh.svg',
  'region': 'src/glyphs/region.svg',
  'registration': 'src/glyphs/registration.svg',
  'reorder': 'src/glyphs/reorder.svg',
  'report': 'src/glyphs/report.svg',
  'report-add': 'src/glyphs/report-add.svg',
  'report-empty': 'src/glyphs/report-empty.svg',
  'response-history': 'src/glyphs/response-history.svg',
  'responses': 'src/glyphs/responses.svg',
  'restart': 'src/glyphs/restart.svg',
  'search': 'src/glyphs/search.svg',
  'send': 'src/glyphs/send.svg',
  'share': 'src/glyphs/share.svg',
  'show': 'src/glyphs/show.svg',
  'stop': 'src/glyphs/stop.svg',
  'success': 'src/glyphs/success.svg',
  'support': 'src/glyphs/support.svg',
  'survey': 'src/glyphs/survey.svg',
  'team': 'src/glyphs/team.svg',
  'top-and-new-responses': 'src/glyphs/top-and-new-responses.svg',
  'top-responses': 'src/glyphs/top-responses.svg',
  'trash': 'src/glyphs/trash.svg',
  'triangle-down': 'src/glyphs/triangle-down.svg',
  'triangle-up': 'src/glyphs/triangle-up.svg',
  'unlock': 'src/glyphs/unlock.svg',
  'up-circle': 'src/glyphs/up-circle.svg',
  'visual-settings': 'src/glyphs/visual-settings.svg',
  'word-cloud': 'src/glyphs/word-cloud.svg'
}
